import MainSelect from "components/innerComponents/AsyncSelect/MainSelect";
import Modals from "components/Modal";
import TableTwo from "components/TableTwo";
import useDonorReport from "hook/reports/useDonorReport";
import { DONOR__ANALYTICS } from "navigation/routes";
import { Link } from "react-router-dom";
import { startCase } from 'lodash'
import { formatMoney } from "utils/functions";

const DonorReport = () => {
  const {
    currentData, setCurrentData, open, setOpen, skipPageReset,
    columns, data, filteredData, setData, current, edit,
    selectedDonor, selectedDonorDetails, isLoading,
    totalAmount, getExcel,
    dateFrom, setDateFrom, dateTo, setDateTo,
  } = useDonorReport()

  return (
    <>
      <div className="container-fluid px-4">
        <div className="d-sm-flex align-items-start justify-content-between mt-4">
          <div>
            <h1>Individual Donor Report</h1>
            <ol className="breadcrumb mb-2">
              <li className="breadcrumb-item">Donors</li>
              <li className="breadcrumb-item active">All</li>
            </ol>
          </div>
          <div className="mb-2 w-25">
            Select Donor to view details
            <MainSelect />
          </div>
          <Link className="btn btn-primary mb-2" to={`../${DONOR__ANALYTICS}`} relative="path">View Analytics</Link>
        </div>

        <div className="card mb-4">
          <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div>
              <i className="fas fa-table me-1"></i>
              Donors
              {selectedDonorDetails && (
                <span className="ms-3 fw-bold">
                  {selectedDonorDetails?.user?.first_name} {selectedDonorDetails?.user?.last_name} — {selectedDonorDetails?.user?.email}
                </span>
              )}
            </div>
          </div>

          <div className="card-body">
            {selectedDonorDetails && (
              <div className="donor-info mb-3">
                <div className="details">
                  {selectedDonorDetails?.donor_phone_number && (
                    <p><strong>Donor phone:</strong> {selectedDonorDetails?.donor_phone_number}</p>
                  )}
                  <p><strong>Donor city:</strong> {selectedDonorDetails?.user?.city?.name}</p>
                  <p><strong>Donor level:</strong> {selectedDonorDetails?.user?.category?.name}</p>
                </div>
              </div>
            )}

            {data?.length > 0 && (
              <div className="alert alert-info d-inline-block py-2 px-3 mb-3">
                <strong>Total Amount:</strong> {formatMoney(totalAmount)}
                {(dateFrom || dateTo) && <span className="ms-2 text-muted small">(filtered)</span>}
              </div>
            )}
            <div className="d-flex w-100">
              
              <div className="d-flex align-items-end gap-2 flex-wrap  ms-auto">
                {data?.length > 0 && (
                  <>
                    <div className="form-inline">
                      <label className="form-label mb-1 small">From</label>
                      <input type='date' className="form-control form-control-sm"
                        value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
                    </div>
                    <div className="form-inline">
                      <label className="form-label mb-1 small">To</label>
                      <input type='date' className="form-control form-control-sm"
                        value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
                    </div>
                    {(dateFrom || dateTo) && (
                      <button className="btn btn-outline-secondary btn-sm"
                        onClick={() => { setDateFrom(''); setDateTo(''); }}>
                        Clear
                      </button>
                    )}
                  </>
                )}
                <button
                  className="btn btn-success btn-sm"
                  onClick={(e) => { e.preventDefault(); getExcel(); }}
                  disabled={!filteredData?.length}
                >
                  <i className="fas fa-file-excel me-1"></i> Download Excel
                </button>
              </div>
            </div>

            <TableTwo
              columns={columns}
              data={filteredData || []}
              setData={setData}
              skipPageReset={skipPageReset}
              fileName={`donor-report-${selectedDonor?.label}`}
              filterTable={false}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>

      <Modals show={open && current === 'view'}
        onHide={() => setOpen(false)} title='View Donation' size='md'>
        <dl className="striped">
          {currentData && Object.entries(currentData)?.map(([key, value]) =>
            typeof value !== 'string' && typeof value !== 'number' ? [] :
              <div key={key} className='row'>
                <dt className='col-4'>{`${startCase(key)} :`}</dt>
                {(!edit || key === 'id') && <dd className='col-8'>{value}</dd>}
                {edit && key !== 'id' && (
                  <div className="col-8">
                    <input
                      className="form-control"
                      type="text"
                      defaultValue={value}
                      onChange={(e) => setCurrentData({ ...currentData, [key]: e.target.value })}
                    />
                  </div>
                )}
              </div>
          )}
        </dl>
      </Modals>
    </>
  )
}

export default DonorReport
